import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { BsCartPlusFill } from "react-icons/bs";
import { BsFillCartDashFill } from "react-icons/bs";
import { dimColor, formatPrice } from "../../functions/utils";
import { addToCart } from "../../functions/addToCart";
import { TranslateContext } from "../../App";
import AddToCartButton from "./AddToCartButton";

import config from "../../configuration.json";

/**
 * Card component for displaying products, blog posts, and categories.
 * Uses React Router Link for client-side navigation to preserve cache.
 * @param {Object} props - Component props
 * @param {string} props.type - Card type: 'general', 'category', 'blog', 'product', 'product-sm'
 * @param {Object} props.content - Card content data
 * @param {Object} props.configuration - Site configuration
 */
function Card({ type, content, configuration }) {
  const [color, setColor] = useState("");
  const language = useContext(TranslateContext).language;
  const [addedToCart, setAddedToCart] = useState(false);

  useEffect(() => {
    if (configuration) {
      setColor(configuration?.colors?.main?.hex);
    }

    // Retrieve the cartItems array from local storage
    let cartItems = localStorage.getItem("cartItems");
    cartItems = cartItems ? JSON.parse(cartItems) : [];

    // Check if the current item is in the cart
    const isAddedToCart = cartItems.some((cartItem) => cartItem.id === content.id);
    // Update the addedToCart state based on the result
    setAddedToCart(isAddedToCart);
  }, [content.id, configuration]);

  const handleAddToCart = (item) => {
    const isAddedToCart = addToCart(item);
    setAddedToCart(isAddedToCart);
  };

  function Type() {
    if (type === "general" || type === "category") {
      return (
        <div className="card">
          <Link className="card-link" to={content.url}>
            <span className="hidden">Link to {content.title}</span>
          </Link>
          <img className="card-image" src={content.image.src} alt={content.image.alt} />
          {content.category && (
            <div className="card-category" style={{ backgroundColor: content.category.color }}>
              <p>{content.category.title}</p>
            </div>
          )}
          <div className="card-inner">
            <div className="card-title">
              <p>{content.title}</p>
            </div>
          </div>
        </div>
      );
    } else if (type === "blog") {
      return (
        <div className="blog-card">
          <Link className="card-link" to={content.url}>
            <span className="hidden">Link to {content.title}</span>
          </Link>
          <img className="card-image" src={content.image.src} alt={content.image.alt} />
          {content.category && (
            <div className="card-category" style={{ backgroundColor: content.category.color }}>
              <p>{content.category.title}</p>
            </div>
          )}
          <div className="blog-card-inner">
            <p className="blog-card-date" style={{ color: "" }}>
              {content.publishDate}
            </p>
            <div className="card-title">
              <p>{content.title}</p>
            </div>
          </div>
        </div>
      );
    } else if (type === "product") {
      return (
        <div className="product-card">
          <Link className="card-link" to={content.url}>
            <span className="hidden">Link to {content.title}</span>
          </Link>{" "}
          <img className="product-card-image" src={content.image.src} alt={content.image.alt} />
          {content.category && (
            <div className="card-category" style={{ backgroundColor: content.category.color }}>
              <p>{content.category.title}</p>
            </div>
          )}
          <div className="product-card-inner">
            <div className="product-card-inner-left">
              <p className="product-card-title">{content.title}</p>
              <p className="product-card-description">{content.description}</p>
            </div>
            <div className="product-card-inner-right">
              <div className="product-card-price-container gap-2 flex flex-col items-end">
                <p style={{ color: configuration.colors.main.hex }} className="product-card-price">
                  {formatPrice(content.price, language, config)}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (type === "product-sm") {
      return (
        <div
          style={{
            filter: content.quantity === 0 ? "grayscale(100%)" : "none",
          }}
          className="product-card-sm"
        >
          <Link className="card-link" to={content.url}>
            <span className="hidden">Link to {content.title}</span>
          </Link>
          <img className="product-card-sm-image" src={content.image.src} alt={content.image.alt} />
          {content.category && (
            <div className="card-category" style={{ backgroundColor: content.category.color }}>
              <span>{content.category.title}</span>
            </div>
          )}
          <div className="product-card-sm-inner">
            <span className="product-card-sm-title">{content.title}</span>
            <div className="product-card-sm-price-container">
              <div className="product-card-sm-price-dual flex flex-row items-center gap-2">
                <span
                  className="product-card-sm-price"
                  style={{
                    color: color,
                  }}
                >
                  {formatPrice(content.price, language, config)}
                </span>
              </div>
              <AddToCartButton
                product={content}
                color={color}
                addedToCart={addedToCart}
                handleAddToCart={handleAddToCart}
              />
            </div>
          </div>
        </div>
      );
    }
    return;
  }
  return configuration && <Type type={type} />;
}

export default Card;
